export default [
    {
        path: '/musteri-listesi',
        name: 'musteri-listesi', 
        meta: { resource: 'admin|dealer|personel' },
        component: () => import('../views/report/musteri_bitis_tarihi')
    },
    {
        path: '/trafik',
        name: 'trafik',
        meta: { resource: 'admin|dealer'},
        component: () => import('../views/report/trafik')
    },
    {
        path: '/musteri-sayisi',
        name: 'musteri-sayisi',
        meta: { resource: 'admin|dealer' },
        component: () => import('../views/report/musteri_sayisi')
    },
    {
        path: '/is-listesi-raporu',
        name: 'kurulumlar',
        meta: { resource: 'admin|personel' },
        component: () => import('../views/report/kurulumlar')
    },
    {
        path: '/extre-raporu',
        name: 'extre-raporu',
        meta: { resource: 'admin|dealer|personel' },
        component: () => import('../views/report/extre_raporu')
    },
    {
        path: '/musteri-bakiye-fark-listesi',
        name: 'musteri-bakiye-fark-listesi',
        meta: { resource: 'admin|dealer' },
        component: () => import('../views/report/musteri_borclu')
    },
    {
        path: '/islem-gecmisleri',
        name: 'islem-gecmisleri',
        meta: { resource: 'admin' },
        component: () => import('../views/report/islem_gecmisleri')
    },
    {
        path: '/taksitliler',
        name: 'taksitliler',
        meta: { resource: 'admin' },
        component: () => import('../views/report/taksitliler')
    }
]
  